import * as s from '../fp-ts/string';
import * as Action from './action';
/**
 * Create action creators where the action types are composed of a given
 * structure. The first parameter describes the scope of the actions and is used
 * (unformated) as a prefix. The second parameter is a payload creator map
 * describing payload creators in a structure which can be nested if desired.
 *
 * ### Example
 * ```ts
 * const Action = make('App')({
 *   click: withoutPayload(),
 *   open: withPayload<{ id: string }>()
 *   element: {
 *     select: withPayload<number>()
 *   }
 * })
 * ```
 */
export var make = function (scope) {
    return function (m) {
        var r = {};
        for (var key in m) {
            var payloadCreator = m[key];
            var type = "".concat(scope, "/").concat(s.toUpperSnakeCase(key));
            switch (typeof payloadCreator) {
                case 'object':
                    r[key] = make(type)(payloadCreator);
                    break;
                case 'function':
                    r[key] = Action.make(type)(payloadCreator);
                    break;
                default:
                    break;
            }
        }
        return r;
    };
};
